package pl.michal_cyran.portfolio.experience.domain

data class Technology(
    val name: String,
    val icon: String,
)